import ChangePasswordForm from '../../components/change-password-form/change-password-form.component';
import './change-password.styles.scss';

const ChangePassword = () => {
    return (
        <div className='change-password-container'>
            <ChangePasswordForm/>
        </div>
    )
}

export default ChangePassword;